<template>
  <div>
    <add-user-dialog
      :dialog-title="dialogTitle"
      :center-dialog-visible="visible"
      :popup-width="'600px'"
      :append-to-body="false"
      :close-model="false"
      @updateVisible="updateVisible"
      @resetPopupData="resetPopupData"
      @submitPopupData="submitPopupData"
    >
      <el-form
        ref="form"
        :model="query"
        :rules="dialogTitle == '修改员工' ? ruleForEdit : rule"
        label-width="120px"
      >
        <el-form-item label="登录账号:" prop="memberName">
          <el-input
            v-model="query.memberName"
            class="input-style"
            :disabled="dialogTitle === '修改员工'"
            @change="handleChangeName"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="dialogTitle !== '修改员工'"
          label="登录密码:"
          prop="password"
        >
          <el-input
            v-model.trim="query.password"
            class="input-style"
          ></el-input>
        </el-form-item>
        <el-form-item label="真实姓名:" prop="realName">
          <el-input v-model="query.realName" class="input-style"></el-input>
        </el-form-item>
        <el-form-item v-if="query.mobile" label="手机号码:" prop="mobile">
          <el-input
            v-model="query.mobile"
            class="input-style"
            :disabled="true"
          ></el-input>
          <el-button
            v-if="dialogTitle === '修改员工'"
            type="primary"
            @click="handleClear(1)"
            >清空</el-button
          >
        </el-form-item>
        <el-form-item v-if="query.email" label="电子邮箱:" prop="email">
          <el-input
            v-model="query.email"
            class="input-style"
            :disabled="true"
          ></el-input>
          <el-button
            v-if="dialogTitle === '修改员工'"
            type="primary"
            @click="handleClear(2)"
            >清空</el-button
          >
        </el-form-item>
        <!--                TODO 12月2日迭代盈科没完成相应功能，代码回退-->
        <!--                <el-form-item label="手机号码:" prop="mobile">-->
        <!--                    <el-input v-model="query.mobile"></el-input>-->
        <!--                </el-form-item>-->
        <!--                <el-form-item label="电子邮箱:" prop="email">-->
        <!--                    <el-input v-model="query.email"></el-input>-->
        <!--                </el-form-item>-->
        <el-form-item label="业务方向:" prop="businessType">
          <el-checkbox-group v-model="query.businessType">
            <el-checkbox
              v-for="(item, index) in businessList"
              :key="index"
              :disabled="businessDirectionDisabled"
              :label="item.businessType"
              >{{ formatBusinessType(item.businessType) }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="所属部门:" prop="department">
          <el-input
            ref="department"
            v-model="query.department"
            class="input-style"
            @focus="selectDepartment"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="dialogTitle !== '修改员工'"
          prop="checked"
          label-width="50px"
        >
          <div class="module-agreement">
            <el-checkbox v-model="query.checked"></el-checkbox>
            <p @click="query.checked = !query.checked">
              我已认真阅读，理解并同意
              <el-button type="text" size="small" @click.stop="openAgreement"
                >《易派客隐私协议》</el-button
              >
              ，向创建个人账号个人用户告知协议内容，个人信息内容和用途并获得同意，创建本公司子账号。
            </p>
          </div>
        </el-form-item>
      </el-form>
    </add-user-dialog>
  </div>
</template>

<script>
import AddUserDialog from '../../../../components/common/epecDialog';
import Api from '../../api/authority/index';
import ApiNesting from '../../api/nesting';
import {
  checkLoginName,
  isPoneAvailable,
  isEmailAvailable,
} from '../../utils/validate';
import { eventBus } from '../../main';

export default {
  name: 'AddUser',
  components: {
    AddUserDialog,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    dialogTitle: {
      type: String,
      required: true,
    },
    userData: {
      type: Object,
    },
  },
  data() {
    const reg =
      /(?![0-9A-Z!@#$_%^*()]+$)(?![0-9a-z!@#$_%^*()]+$)(?![a-zA-Z!@#$_%^*()]+$)[0-9A-Za-z!@#$_%^*()]{8,20}$/;
    // let reg = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,20}$/;
    const validatePass = (rule, value, callback) => {
      console.log(reg.test(value));
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (
        (this.memberName && this.memberName == value.toLowerCase()) ||
        value.toLowerCase().indexOf(this.memberName) != -1
      ) {
        callback(new Error('密码不得包含用户名'));
      } else if (!reg.test(value)) {
        callback(new Error('密码应是8-20位必须同时包括大小写字母及数字！'));
      } else if (this.passwordState == '101') {
        callback(new Error('密码过于简单，请重新设置密码'));
      }
      callback();
    };
    return {
      query: {
        memberName: '',
        realName: '',
        mobile: '',
        email: '',
        department: ' ',
        orgId: '',
        businessType: [],
        checked: null,
      },
      selectDepartmentDialogShow: false,
      rule: {
        memberName: [
          { required: true, message: '请填写登录账号', trigger: 'blur' },
          { validator: checkLoginName, trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请填写登录密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' },
        ],
        realName: [
          { required: true, message: '请填写真实姓名', trigger: 'blur' },
        ],
        mobile: [
          { required: true, message: '请填写电话号码', trigger: 'blur' },
          { validator: isPoneAvailable, trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请填写用户邮箱', trigger: 'blur' },
          { validator: isEmailAvailable, trigger: 'blur' },
        ],
        businessType: [
          { required: true, message: '请选择业务方向', trigger: 'blur' },
        ],
        department: [
          { required: true, message: '请选择部门', trigger: 'blur' },
        ],
        checked: [
          {
            required: true,
            message: '请阅读《易派客隐私协议》',
            trigger: 'change',
          },
        ],
      },
      ruleForEdit: {
        realName: [
          { required: true, message: '请填写真实姓名', trigger: 'blur' },
        ],
        businessType: [
          { required: true, message: '请选择业务方向', trigger: 'blur' },
        ],
        department: [
          { required: true, message: '请选择部门', trigger: 'blur' },
        ],
      },
      businessList: [],
      passwordState: '',
      memberName: null,
    };
  },
  computed: {
    businessDirectionDisabled() {
      // 企业管理员不可操作自身业务方向
      if (
        this.dialogTitle === '修改员工' &&
        this.$store.state.USERINFO.memberId === this.userData?.memberId
      ) {
        return true;
      }
      return false;
    },
  },
  created() {
    if (this.dialogTitle !== '新增员工') {
      this.getDepartmentById();
    }
    this.getBusinessType();
    eventBus.$on('getDepartmentData', (target) => {
      this.query.department = target.shortFullName;
      this.query.orgId = target.orgId;
    });
    console.log(this.userData, 'userData');
  },
  methods: {
    updateVisible() {},
    handleChangeName(row) {
      this.memberName = row;
    },
    resetPopupData() {
      this.$emit('close');
    },
    submitPopupData() {
      if (this.query.password) {
        // 弱口令
        const params = {
          memberId: null,
          password: this.query.password,
        };
        ApiNesting.weakPasswordCheck(params).then((res) => {
          if (res.data.status != 'ok') {
            this.passwordState = res.data.status;
          }
          this.submit();
        });
      } else {
        this.submit();
      }
    },
    // 提交
    submit() {
      if (!this.query.department || this.query.department == ' ') {
        this.$message({
          type: 'error',
          message: '请选择部门',
        });
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.dialogTitle == '新增员工') {
            const params = this.formatParams();
            Api.insertUser(params).then((res) => {
              if (res.code == '200') {
                this.$message({
                  type: 'success',
                  message: '新增员工成功',
                });
                this.$emit('close');
              }
            });
          } else {
            // TODO 12月2日迭代盈科没有完成，代码回退
            // if(!this.query.email && !this.query.mobile){
            //     this.$message({
            //         type:'error',
            //         message:'此账号的手机号码（电子邮箱）还未绑定，不能清空电子邮箱（手机号码）！'
            //     })
            //     return
            // }
            const params = {
              memberId: this.userData.memberId,
              orgId: this.query.orgId,
              realName: this.query.realName,
              mobile: this.query.mobile,
              email: this.query.email,
              businessType:
                this.query.businessType.length == 2
                  ? 3
                  : this.query.businessType[0],
            };
            Api.updateUser(params).then((res) => {
              if (res.code == '200') {
                this.$message({
                  type: 'success',
                  message: '修改员工成功',
                });
                this.$emit('close');
              }
            });
          }
        } else {
          this.passwordState = '';
          console.log('error');
        }
      });
    },
    selectDepartment() {
      this.$emit('openSelectDepartmentDialog');
    },
    closeSelectDepartmentDialog() {
      this.$refs.department.focus();
      this.selectDepartmentDialogShow = false;
    },
    getCurrentNode(val) {
      this.query.department = val.shortFullName;
      this.query.orgId = val.orgId;
    },
    async getDepartmentById() {
      const params = {
        memberId: this.userData.memberId,
      };

      const res = await Api.getDepartmentById(params);
      this.query.realName = this.userData.realName;
      this.query.memberName = this.userData.memberName;
      this.query.mobile = this.userData.mobile;
      this.query.email = this.userData.email;
      this.query.department = res.data.orgName ? res.data.orgName : ' ';
      this.query.orgId = res.data.orgId;
      if (res.data.businessType == 3) {
        this.query.businessType.push(1);
        this.query.businessType.push(2);
      } else {
        this.query.businessType.push(res.data.businessType);
      }
    },
    getBusinessType() {
      const params = {};
      Api.getBusinessType(params).then((res) => {
        if (res.code == '200') {
          this.businessList = res.data;
        }
      });
    },
    formatBusinessType(val) {
      let res = '';
      switch (val) {
        case 2:
          res = '供应商';
          break;
        case 1:
          res = '采购商';
          break;
      }
      return res;
    },
    formatParams() {
      const res = {};
      res.memberName = this.query.memberName;
      res.password = this.query.password;
      res.mobile = this.query.mobile;
      res.email = this.query.email;
      res.department = this.query.department;
      res.orgId = this.query.orgId;
      res.realName = this.query.realName;
      res.businessType =
        this.query.businessType.length == 2 ? 3 : this.query.businessType[0];
      return res;
    },
    handleClear(val) {
      if (val === 1) {
        this.query.mobile = '';
      } else {
        this.query.email = '';
      }
    },
    openAgreement() {
      this.$emit('openPrivacyAgreement');
    },
  },
};
</script>

<style scoped>
.input-style {
  width: 350px;
}
.module-agreement {
  display: flex;
  align-items: center;
  color: #333;
  font-family: Source Han Sans CN;
  font-size: 14px;
  font-weight: 500;
  p {
    margin-left: 10px;
    line-height: 18px;
  }
  ::v-deep .el-button + .el-button {
    margin-left: 0;
  }
  ::v-deep .el-button--small {
    padding: 0;
  }
}
</style>
